import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { removeAllocationError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  allocation: Boundaries["removeAllocation"]["request"],
): State {
  const index = state.findIndex(
    (res) => res.allocation.uuid === allocation.uuid,
  );

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          allocation,
          request: setRequestStateToPending(),
          error: removeAllocationError,
        },
        ...state.slice(index + 1),
      ]
    : [
        ...state,
        {
          allocation,
          request: setRequestStateToPending(),
          error: removeAllocationError,
        },
      ];
}

function handleSuccess(
  state: State,
  allocation: Boundaries["removeAllocation"]["success"],
): State {
  return state.map((res) =>
    res.allocation.uuid === allocation.uuid
      ? {
          allocation,
          request: setRequestStateToSuccess(),
          error: removeAllocationError,
        }
      : res,
  );
}

function handleFailure(
  state: State,
  { allocation, error }: Boundaries["removeAllocation"]["failure"],
): State {
  return state.map((res) =>
    res.allocation.uuid === allocation.uuid
      ? { allocation, request: setRequestStateToFailure(), error }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeAllocationRequested]: handleRequest,
    [events.removeAllocationSucceeded]: handleSuccess,
    [events.removeAllocationFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
